//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamTraProKategorieUdalosti.ts						</Name>
//    <Description> Dialog seznam Kategorie ud�lost�										</Description>
//    <Author>      ffiala													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-11-08                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=482.71.X1
//AdtGeneratorConfig:[ T:(gincevn) V1:(ktg_evn,ktg_evn_txt,k_v,k_s,dat_do,dat_do_exp,dat_do_prn,dat_do_xml,dat_do_evn,dat_zmena,dat_do_akt) V2:(priz_gen,priz_prn,priz_xml,priz_evn,zmenu_prov,priz_zobr) K1:() K2:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
    export class SeznamTraProKategorieUdalosti extends GContentBase<SeznamTraProKategorieUdalostiDesigner>  {

		//#region *** onContentReady && Init ***

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
        private init() {

            // inicializace hodnot od rodice
            SeznamTraProKategorieUdalostiDesigner.SeznamTraProKategorieUdalostiDesignerInit(this);

			this.setTitle();
			this.createMenuButtons();
            this.createGrid();
            this.createMenuBar();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
                this.title = "jres:29801876" 	//RC 29801876 : Kategorie ud�lost�
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			var bar = this.setMenuButtons();
			return bar;
		}

		/**
		 * createMenuButtons
		 */
        private createMenuButtons(): void {
            //this.novyZaznamButton();
			this.detailButton();
		}

		/**
		 * vytvo�it menu
		 */
		private createMenuBar(): void {
			this.menuBar(this.setMenuButtons());
		}

		private setMenuButtons(): MenuParams[] {

			const bar: MenuParams[] = [];

            //bar.push({
            //    favorite: true,
            //    primary: true,
            //    action: this.actions.actNovy
            //})

			bar.push({
				favorite: true,
				action: this.actions.actDetail
			})

			return bar;
        }

        //private novyZaznamButton() {
        //    this.actions.add(new GAction({
        //        name: "actNovy",
        //        icon: "gi-plus",
        //        caption: "jres:32000121",			//RC 32000121 : Nov� z�znam
        //        run: () => {
        //            var newRecord = true;
        //            this.openDetail(newRecord);
        //        }
        //    }));
        //}

		/**
		 * detail button
		 */
		private detailButton(): void {
			this.actions.add(new GAction({
				name: "actDetail",
				icon: "gi-detail",
				caption: "jres:32131033",			//RC 32131033 : Detail
				run: () => {
					this.openDetail();
				}
			}));
		}


		//#endregion

		//#region *** detail ***

		/**
		 * otev��t detail
		 */
        private openDetail(_new?: boolean): void {

            var newRecord = _new == null ? false : _new;

            if (Utils.isGridEmpty(this.grid)) {

                if (newRecord === true) {
                    // nov� z�znam p�i pr�zdn�m gridu
                    Dialogs.DetailTraProKategorieUdalostiDlg(this, { ktg_evn: null, grid: this.grid, newRecord: newRecord }).done((data: any) => {
                        //this.reloadDataOnGrid();
                    });
                }
                else {
                    this.showFlash("jres:32131036", "g-state-warning", 2500, "id-flash-empty-grid-detail"); //RC 32131036 : Seznam je pr�zdn�, nelze p�ej�t na detail.
                }
			}
            else {

				var selection = this.grid.ggrid("getSelection");

                // vybran� jeden ��dek
				if (selection.length === 1) {
                    var data: any = selection[0];
                    Dialogs.DetailTraProKategorieUdalostiDlg(this, { ktg_evn: data.ktg_evn, grid: this.grid, newRecord: newRecord }).done((data: any) => {
						//this.reloadDataOnGrid();		// t.hazmuka: hazel chybu sidebaru a vyhodnotil jsem, ze tu neni potreba, kdyz je refresh i v menu
					});
                }

				// vybr�no v�ce ��dk�
				else {
					this.showFlash("jres:32131037", "g-state-warning", 2500, "id-flash-select-more-rows-grid-detail"); //RC 32131037 : Nelze p�ej�t na detail s v�ce vybran�mi ��dky.
				}
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvo�it seznam - definice objektu GRIDu, nav�zan�ch ud�lost� atd... */
		private createGrid(): void {

            this.grid = $("<div>").gautofit().appendTo(this.element);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
					name: "doubleClickGridSeznam",
					run: (ev, ctx) => {
						this.openDetail();
					}
				}),
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
                sort: "ktg_evn",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			var panel = this.createPanel();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// o�et�en� zav�en� contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

	}

}
